/*
  Sticky cart purchase-option picker <-> Loop subscription widget.

  The picker has no name="selling_plan": Loop claims every field with that name
  and takes over its value, so the sticky form always posted a one-time purchase.
  The chosen plan is injected as a hidden input on submit instead.
*/
(function () {
  var LOOP_SELECTED =
    '.loop-widget-purchase-options-container .loop-widget-purchase-option-selected, ' +
    '.loop-widget-purchase-options-container [aria-checked="true"]';

  function init() {
    var select = document.getElementById('selling_plan_sticky_select');
    if (!select) return;

    var form = select.closest('form');
    if (!form) return;

    var userChose = false;

    // Capture phase runs before <product-form>'s own submit handler builds its FormData.
    document.addEventListener(
      'submit',
      function (event) {
        if (event.target !== form) return;

        Array.prototype.slice.call(form.elements).forEach(function (el) {
          if (el.name === 'selling_plan' && !el.closest('.loop-widget-container')) el.remove();
        });

        if (!select.value) return;

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.value = select.value;
        form.appendChild(input);
      },
      true
    );

    // null = widget not rendered, '' = one-time, otherwise a selling plan id.
    function loopPlan() {
      var option = document.querySelector(LOOP_SELECTED);
      if (!option) return null;
      if (option.hasAttribute('data-loop-widget-onetime-purchase-option')) return '';
      var frequency = option.querySelector('select[name="selling_plan"]');
      return frequency && frequency.value ? frequency.value : '';
    }

    // Follow the widget only until the shopper picks something here: Loop resets
    // its own frequency dropdown as it re-renders, which would otherwise overwrite
    // their choice.
    function pullFromLoop() {
      if (userChose) return;
      var plan = loopPlan();
      if (plan === null || select.value === plan) return;
      if (select.querySelector('option[value="' + plan + '"]')) select.value = plan;
    }

    // Show the selected plan's price in the sticky bar. data-price comes from the
    // same money filter the price snippet uses, so the formats always match.
    var stickyCart = select.closest('.sticky-cart');
    var priceItems = stickyCart
      ? stickyCart.querySelectorAll(
          '.price__regular .price-item--regular:not(.variant-item__old-price) bdi, .price__sale .price-item--sale bdi'
        )
      : [];

    function syncPrice() {
      var option = select.options[select.selectedIndex];
      var price = option && option.getAttribute('data-price');
      if (!price) return;
      Array.prototype.forEach.call(priceItems, function (el) {
        if (el.textContent !== price) el.textContent = price;
      });
    }

    select.addEventListener('change', function () {
      userChose = true;
      syncPrice();
    });

    // Loop re-renders itself, so listeners alone lose track of its selection.
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        pullFromLoop();
        syncPrice();
      });
    }).observe(document.querySelector('product-info') || document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-checked', 'class'],
    });

    pullFromLoop();
    syncPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
